import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"


export const isLoadingUserSettingTierData = signal(true)
export const userSettingTierData = signal([])
export const userSettingsTierFormData = signal({})

// Computed
export const isOpenUserSettingsTierDrawer = computed(() => !isEmpty(userSettingsTierFormData.value))
export const isEditUserSettingsTierDrawer = computed(() => userSettingsTierFormData.value?.id !== null)

// Functions
export const clearUserSettingTierSignals = () => batch(() => {
	isLoadingUserSettingTierData.value = true
	userSettingTierData.value = []
	userSettingsTierFormData.value = {}
})